"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getPayloadConfig: ()=>getPayloadConfig
});
const external_uuid_namespaceObject = require("uuid");
const useSeti_js_namespaceObject = require("../utils/useSeti.js");
const getPayloadConfig = ({ customerName, locale, startingChatMessagesPayload, viewType, webstats })=>{
    const dateToday = new Date().toString();
    const rguidSeed = (0, external_uuid_namespaceObject.v4)();
    const standardConfig = {
        cguid: webstats?.clientGUID || '',
        cityName: locale?.city || '',
        countryCode: locale?.countryName || '',
        customerName,
        dateToday,
        isSessionActive: true,
        latitude: locale?.latitude || '',
        longitude: locale?.longitude || '',
        resolvedClientIP: webstats?.resolvedClientIP || '',
        stateCode: locale?.region || '',
        returnJSONResponse: true
    };
    const shouldEnableInlineWebSearchResultCitation = true;
    const shouldUseHotelImages = (0, useSeti_js_namespaceObject.useSeti)({
        testName: 'PENNY_IMAGE_DISPLAYING',
        shouldFireImpression: false
    });
    const payloadConfig = {
        LANDING: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                productId: 5,
                rguid: `HOMEPAGE-${rguidSeed}`,
                ...standardConfig,
                ...startingChatMessagesPayload,
                hotelPayload: {
                    shouldUseSearchHotelsFeature: true,
                    isHotelSearchDateSelection: true,
                    isShowMoreListingCards: (0, useSeti_js_namespaceObject.useSeti)({
                        testName: 'CHATBOT_HOTEL_CARDS_LOAD_MORE',
                        shouldFireImpression: false
                    })
                },
                enabledActions: {
                    shouldUseHotelImages,
                    shouldEnableFeedbackIntent: true,
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableLLMBasedResult: true,
                    shouldEnableSelectedTripQuickActions: true,
                    shouldUseDynamicQuickActionsChips: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableMarkdownTemplate: true,
                    isPennyAgentEnabled: true
                }
            }
        },
        PORTAL: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                isSessionActive: true,
                productId: -1,
                ...standardConfig,
                ...startingChatMessagesPayload,
                hotelPayload: {
                    shouldUseSearchHotelsFeature: true,
                    isHotelSearchDateSelection: true,
                    isShowMoreListingCards: (0, useSeti_js_namespaceObject.useSeti)({
                        testName: 'CHATBOT_HOTEL_CARDS_LOAD_MORE',
                        shouldFireImpression: false
                    })
                },
                enabledActions: {
                    shouldUseHotelImages,
                    shouldEnableFeedbackIntent: true,
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableLLMBasedResult: true,
                    shouldEnableSelectedTripQuickActions: true,
                    shouldUseDynamicQuickActionsChips: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableMarkdownTemplate: true,
                    isPennyAgentEnabled: true
                },
                pennyPortalPayload: {
                    shouldUseSearchHotelsFeature: true
                }
            }
        },
        STAYDETAILS: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                productId: 5,
                ...startingChatMessagesPayload,
                hotelPayload: {
                    shouldUseSearchHotelsFeature: true,
                    isHotelSearchDateSelection: true,
                    ...startingChatMessagesPayload.hotelPayload
                },
                enabledActions: {
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableLLMBasedResult: true,
                    isPennyAgentEnabled: true,
                    shouldEnableMarkdownTemplate: true,
                    shouldUseHotelImages
                }
            }
        },
        STAYLISTINGS: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                productId: 5,
                ...startingChatMessagesPayload,
                hotelPayload: {
                    shouldUseSearchHotelsFeature: true,
                    isHotelSearchDateSelection: true,
                    ...startingChatMessagesPayload.hotelPayload
                },
                enabledActions: {
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableLLMBasedResult: true,
                    shouldEnableMarkdownTemplate: true,
                    isPennyAgentEnabled: true
                }
            }
        },
        ITINERARY: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                isSessionActive: true,
                ...startingChatMessagesPayload,
                enabledActions: {
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableLLMBasedResult: true,
                    shouldEnableMarkdownTemplate: true,
                    isPennyAgentEnabled: true
                }
            }
        },
        DRIVE: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                ...startingChatMessagesPayload,
                carPayload: {
                    ...startingChatMessagesPayload.carPayload
                },
                enabledActions: {
                    isPennyAgentEnabled: true,
                    shouldEnableMarkdownTemplate: true,
                    shouldEnableInlineWebSearchResultCitation
                }
            }
        },
        CHECKOUT: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                ...startingChatMessagesPayload,
                hotelPayload: {
                    shouldUseChangeHotelDatesFeature: true,
                    shouldUseChangeHotelRoomsFeature: true,
                    shouldUseSwitchToPayLaterHotelFeature: true,
                    shouldDisplayChangeDatesBtn: true,
                    shouldUseSearchHotelsFeature: true,
                    shouldUseBookingFeature: true,
                    ...startingChatMessagesPayload.hotelPayload
                },
                flightPayload: {
                    shouldUseBookingFeature: true,
                    ...startingChatMessagesPayload.flightPayload
                },
                carPayload: {
                    shouldUseBookingFeature: true,
                    ...startingChatMessagesPayload.carPayload
                },
                packagePayload: {
                    shouldUseBookingFeature: true,
                    ...startingChatMessagesPayload.packagePayload
                },
                enabledActions: {
                    shouldEnableInlineLocationMetadata: true,
                    shouldEnableInlineWebSearchResultCitation,
                    shouldEnableLLMBasedResult: true,
                    isPennyAgentEnabled: true,
                    shouldEnableMarkdownTemplate: true
                }
            }
        },
        FLYDETAILS: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                ...startingChatMessagesPayload,
                flightPayload: {
                    ...startingChatMessagesPayload.flightPayload
                },
                enabledActions: {
                    shouldEnableInlineWebSearchResultCitation,
                    isPennyAgentEnabled: true,
                    shouldEnableMarkdownTemplate: true
                }
            }
        },
        FLYLISTINGS: {
            isMobile: webstats?.isMobile,
            submitChatMessagesPayload: {
                ...standardConfig,
                ...startingChatMessagesPayload,
                flightPayload: {
                    ...startingChatMessagesPayload.flightPayload
                },
                enabledActions: {
                    shouldEnableInlineWebSearchResultCitation,
                    isPennyAgentEnabled: true,
                    shouldEnableMarkdownTemplate: true
                }
            }
        }
    };
    const config = payloadConfig[viewType];
    if (!config) throw new Error(`No payload configuration found for viewType: ${viewType}. Add configuration to payloadConfig object in /react-components/penny-chat-bot/src/config/payloadConfig.ts. `);
    return config;
};
exports.getPayloadConfig = __webpack_exports__.getPayloadConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getPayloadConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
